import Modal from '@oncolens/oncolens-ui/lib/components/Common/Modal';
import DefaultButton, {
  DefaultButtonColor,
} from '@oncolens/oncolens-ui/lib/components/FormControls/DefaultButton';
import React from 'react';
import { FaTrash } from 'react-icons/fa';

interface Props {
  onDelete: (toggle: () => void) => Promise<any>;
  modalTitle: string;
  modalContent: string;
  deleteItemTestSelector: string;
  deleteItemConfirmationTestSelector: string;
  deleteModalTestSelector: string;
}

function ActionsColumn({
  onDelete,
  modalTitle,
  modalContent,
  deleteItemTestSelector,
  deleteModalTestSelector,
  deleteItemConfirmationTestSelector,
}: Props) {
  return (
    <Modal
      testSelector={deleteModalTestSelector}
      triggerElement={
        <FaTrash
          className="box-content p-2 text-gray-600 transition-colors duration-200 cursor-pointer hover:text-gray-800"
          data-cy={deleteItemTestSelector}
        />
      }>
      <Modal.Header title={modalTitle} showClose />
      <Modal.Content>
        <p>{modalContent}</p>
      </Modal.Content>
      <Modal.Buttons className="flex space-x-2.5 items-center">
        {(toggle) => (
          <>
            <DefaultButton className="ml-auto" onClick={toggle} color={DefaultButtonColor.Neutral}>
              Cancel
            </DefaultButton>
            <DefaultButton
              className=""
              onClick={() => onDelete(toggle)}
              color={DefaultButtonColor.Destructive}
              testSelector={deleteItemConfirmationTestSelector}>
              Delete
            </DefaultButton>
          </>
        )}
      </Modal.Buttons>
    </Modal>
  );
}

export { ActionsColumn as default };
